'use client';

import { c as _c } from "react/compiler-runtime";
import { ReactNode } from 'react';
import { useIsClient } from 'usehooks-ts';
import IconLike from '@/components/assets/icon_like.svg';
import IconLikeBordered from '@/components/assets/icon_like_bordered.svg';
import IconLikeFilled from '@/components/assets/icon_like_filled.svg';
import IconWatch from '@/components/assets/icon_watch.svg';
import CountView from '@/components/CountView';
import MoreAction from '@/components/MoreAction';
import { CardTitle } from '@/components/ui/card';
import VerifiedBadge from '@/components/VerifiedBadge';
import ViverseCard from '@/components/ViverseCard';
import { useFormatVODTime } from '@/hooks/useFormatVODTime';
import { Link } from '@/i18n/navigation';
import { extractRoomIdFromUrl } from '@/lib/cms';
import { cn } from '@/lib/utils';
import type { WorldCardInfo } from '@/types/viverse-world-card';
type ActionWorldCardHeaderProps = {
  id?: string;
  title?: string;
  href?: string;
  externalLink?: string;
  hubsUrl?: string;
  info: WorldCardInfo;
  showMoreAction?: boolean;
  moreActionContent?: ReactNode;
  shareOnly?: boolean;
  isCoOwnedRoom?: boolean;
  onAfterMutatingWorld?: (deleteRoomId?: string) => void;
  stopSetAsFeatured?: boolean;
  customDesc?: string;
  ownerDisplayName?: string;
  ownerId?: string;
  ownerIsVerified?: boolean;
  viewCount?: number;
  likeCount?: number;
  hideLiked?: boolean;
  isLiked?: boolean;
  isVOD?: boolean;
  vodLastUpdateDate?: string;
  handleClickLike?: (e: React.MouseEvent) => void;
  noAccess?: boolean;
};
export default function ActionWorldCardHeader(t0) {
  const $ = _c(62);
  const {
    id,
    title,
    href,
    externalLink,
    hubsUrl,
    info,
    showMoreAction,
    moreActionContent,
    shareOnly,
    isCoOwnedRoom,
    onAfterMutatingWorld,
    stopSetAsFeatured,
    customDesc,
    ownerDisplayName,
    ownerId,
    ownerIsVerified,
    viewCount,
    likeCount,
    hideLiked,
    isLiked,
    isVOD,
    vodLastUpdateDate,
    handleClickLike,
    noAccess
  } = t0;
  const isClient = useIsClient();
  const t1 = href || externalLink || hubsUrl || "/";
  let t2;
  if ($[0] !== t1) {
    t2 = extractRoomIdFromUrl(t1);
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const targetUrl = t2;
  const formatVODTime = useFormatVODTime();
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="pointer-events-none absolute top-0 left-1/2 z-1 hidden size-[120px] -translate-x-1/2 -translate-y-[80%] rounded-full bg-[#00B2E2]/80 opacity-0 blur-[60px] transition-opacity duration-300 group-hover:opacity-100 lg:block" />;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== title) {
    t4 = <CardTitle className="subheader-3 truncate font-medium">{title}</CardTitle>;
    $[3] = title;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t4 || $[6] !== targetUrl) {
    t5 = <Link href={targetUrl} className="overflow-hidden after:absolute after:inset-0" draggable={false} prefetch={false}>{t4}</Link>;
    $[5] = t4;
    $[6] = targetUrl;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== handleClickLike || $[9] !== hideLiked || $[10] !== isClient || $[11] !== isLiked || $[12] !== isVOD) {
    t6 = !hideLiked && !isVOD && isClient && <div className="relative z-interactive cursor-pointer opacity-0 transition-opacity duration-150 group-hover:opacity-100" onClick={handleClickLike}>{isLiked ? <IconLikeFilled className="size-6 p-0.5" /> : <IconLikeBordered className="size-6 p-0.5" />}</div>;
    $[8] = handleClickLike;
    $[9] = hideLiked;
    $[10] = isClient;
    $[11] = isLiked;
    $[12] = isVOD;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== id || $[15] !== info || $[16] !== isClient || $[17] !== isCoOwnedRoom || $[18] !== moreActionContent || $[19] !== onAfterMutatingWorld || $[20] !== shareOnly || $[21] !== showMoreAction || $[22] !== stopSetAsFeatured) {
    t7 = showMoreAction && id && isClient && <div className="relative flex items-center"><MoreAction info={info} shareOnly={shareOnly} isCoOwnedRoom={isCoOwnedRoom} onAfterMutatingWorld={onAfterMutatingWorld} stopSetAsFeatured={stopSetAsFeatured} hideDelete={true} collapseEmptySeparator={true}>{moreActionContent}</MoreAction></div>;
    $[14] = id;
    $[15] = info;
    $[16] = isClient;
    $[17] = isCoOwnedRoom;
    $[18] = moreActionContent;
    $[19] = onAfterMutatingWorld;
    $[20] = shareOnly;
    $[21] = showMoreAction;
    $[22] = stopSetAsFeatured;
    $[23] = t7;
  } else {
    t7 = $[23];
  }
  let t8;
  if ($[24] !== t6 || $[25] !== t7) {
    t8 = <div className="flex gap-2">{t6}{t7}</div>;
    $[24] = t6;
    $[25] = t7;
    $[26] = t8;
  } else {
    t8 = $[26];
  }
  let t9;
  if ($[27] !== t5 || $[28] !== t8) {
    t9 = <div className="flex items-center justify-between">{t5}{t8}</div>;
    $[27] = t5;
    $[28] = t8;
    $[29] = t9;
  } else {
    t9 = $[29];
  }
  let t10;
  if ($[30] !== externalLink || $[31] !== formatVODTime || $[32] !== isVOD || $[33] !== likeCount || $[34] !== noAccess || $[35] !== viewCount || $[36] !== vodLastUpdateDate) {
    t10 = !externalLink && <div className={cn("caption text-vive-primary-30 flex items-center gap-2", {
      invisible: noAccess
    })}><CountView icon={<IconWatch />} count={viewCount ?? 0} />{!isVOD && <CountView icon={<IconLike />} count={likeCount ?? 0} />}{isVOD && vodLastUpdateDate && formatVODTime(vodLastUpdateDate)}</div>;
    $[30] = externalLink;
    $[31] = formatVODTime;
    $[32] = isVOD;
    $[33] = likeCount;
    $[34] = noAccess;
    $[35] = viewCount;
    $[36] = vodLastUpdateDate;
    $[37] = t10;
  } else {
    t10 = $[37];
  }
  let t11;
  if ($[38] !== noAccess) {
    t11 = cn("flex items-center justify-between", {
      invisible: noAccess
    });
    $[38] = noAccess;
    $[39] = t11;
  } else {
    t11 = $[39];
  }
  let t12;
  if ($[40] !== customDesc) {
    t12 = cn("caption", {
      hidden: customDesc
    });
    $[40] = customDesc;
    $[41] = t12;
  } else {
    t12 = $[41];
  }
  let t13;
  if ($[42] !== t12) {
    t13 = <span className={t12}>by</span>;
    $[42] = t12;
    $[43] = t13;
  } else {
    t13 = $[43];
  }
  const t14 = `/profile/${ownerId}`;
  const t15 = customDesc ? customDesc : ownerDisplayName;
  let t16;
  if ($[44] !== t15) {
    t16 = <span className="text-vive-brand-40 truncate">{t15}</span>;
    $[44] = t15;
    $[45] = t16;
  } else {
    t16 = $[45];
  }
  let t17;
  if ($[46] !== ownerIsVerified) {
    t17 = <VerifiedBadge isVerified={ownerIsVerified} />;
    $[46] = ownerIsVerified;
    $[47] = t17;
  } else {
    t17 = $[47];
  }
  let t18;
  if ($[48] !== t14 || $[49] !== t16 || $[50] !== t17) {
    t18 = <Link href={t14} className="text-vive-brand-40 caption relative flex max-w-[150px] cursor-pointer items-center gap-1 leading-none hover:underline" draggable={false} prefetch={false}>{t16}{t17}</Link>;
    $[48] = t14;
    $[49] = t16;
    $[50] = t17;
    $[51] = t18;
  } else {
    t18 = $[51];
  }
  let t19;
  if ($[52] !== t13 || $[53] !== t18) {
    t19 = <div className="text-vive-primary-30 flex items-center gap-1">{t13}{t18}</div>;
    $[52] = t13;
    $[53] = t18;
    $[54] = t19;
  } else {
    t19 = $[54];
  }
  let t20;
  if ($[55] !== t11 || $[56] !== t19) {
    t20 = <div className={t11}>{t19}</div>;
    $[55] = t11;
    $[56] = t19;
    $[57] = t20;
  } else {
    t20 = $[57];
  }
  let t21;
  if ($[58] !== t10 || $[59] !== t20 || $[60] !== t9) {
    t21 = <ViverseCard.Header className="relative mt-2 gap-1">{t3}{t9}{t10}{t20}</ViverseCard.Header>;
    $[58] = t10;
    $[59] = t20;
    $[60] = t9;
    $[61] = t21;
  } else {
    t21 = $[61];
  }
  return t21;
}